import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function SupplierNamesConfig() {
  const { user } = useAuth();
  const isAdmin = user?.role === "Admin";
  const [list, setList] = useState([]);
  const [vals, setVals] = useState({});
  const [msg, setMsg] = useState("");
  const load = () => api.get("/report/supplier-names").then(r => { setList(r.data); setVals(Object.fromEntries(r.data.map(x => [x.stored, x.shown]))); });
  useEffect(() => { load(); }, []);
  async function save(x, shown) {
    try { await api.put("/report/supplier-names", { stored: x.stored, shown }); setMsg(`Saved: ${x.stored} → ${shown || x.auto}`); load(); }
    catch (e) { setMsg(e?.response?.data?.detail || "Couldn't save"); }
  }
  return (
    <div className="card space-y-3" data-testid="supplier-names-config">
      <h2 className="text-silver">Supplier names on reports</h2>
      <div className="text-xs opacity-60">How each supplier is printed on Report Builder reports. The name stored on the bill is never changed. Blank = use the automatic clean name.</div>
      {msg && <div className="text-xs text-green-400" data-testid="supplier-names-msg">{msg}</div>}
      <div className="overflow-x-auto">
        <table className="table text-sm">
          <thead><tr><th>As stored on bills</th><th>Shown on reports</th><th></th></tr></thead>
          <tbody>{list.map((x, i) => (
            <tr key={x.stored} data-testid={`supplier-name-row-${i}`}>
              <td className="opacity-80">{x.stored}</td>
              <td><input className="input w-full min-w-[160px]" value={vals[x.stored] ?? ""} disabled={!isAdmin} onChange={e => setVals(v => ({ ...v, [x.stored]: e.target.value }))} data-testid={`supplier-name-input-${i}`} />
                {!x.custom && <div className="text-[11px] opacity-50">automatic</div>}</td>
              <td className="whitespace-nowrap">{isAdmin && <>
                <button className="btn-ghost text-xs" onClick={() => save(x, vals[x.stored] || "")} data-testid={`supplier-name-save-${i}`}>Save</button>
                {x.custom && <button className="btn-ghost text-xs" onClick={() => save(x, "")} data-testid={`supplier-name-reset-${i}`}>Reset</button>}</>}</td>
            </tr>))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
